module.exports = __webpack_public_path__ + "img/head-side-heart.7e58c920.svg";